import { p as promiseResolve, b as bootstrapLazy } from './index-2bdd3be5.js';

/*
 Stencil Client Patch Esm v2.8.0 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["connect-modal",[[1,"connect-modal",{"authOptions":[16],"hasOpenedInstall":[32]}]]]], options);
  });
};

export { defineCustomElements };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/connect-ui/dist/esm/loader.js
// module id = null
// module chunks = 